import { MatterStateType } from 'types/matters';

export const MATTER_FINAL_STATES: readonly string[] = [
    MatterStateType.COMPLETED,
    MatterStateType.OFFER_LOST,
    MatterStateType.OFFER_WON,
];

export function isMatterClosed(stateCode?: string | null): boolean {
    return stateCode === MatterStateType.COMPLETED;
}

export function isMatterInProgress(stateCode?: string | null): boolean {
    return stateCode === MatterStateType.IN_PROGRESS;
}

export function isMatterInFinalState(stateCode?: string | null): boolean {
    return !!stateCode && MATTER_FINAL_STATES.includes(stateCode);
}
